/* global bootstrap */

import React, { useContext, useEffect, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import UserContext from "../../../utils/Contexts/UserContext";
import toast from "react-hot-toast";
import axiosInstance from "../../../utils/Requests/axios";

function ChangePassword() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const { userData } = useContext(UserContext);
  const [formValues, setFormValues] = useState({
    opassword: "",
    password: "",
    cpassword: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formValues.password !== formValues.cpassword) {
      toast.error(t("Passwords do not match."));
      return;
    }

    if (formValues.password && formValues?.password.length < 8) {
      toast.error(t("Password must be at least 8 characters long."));
      return;
    }

    try {
      const url = `/auth/${userData?.uuid}/change-password`;
      await axiosInstance.put(url, formValues);
      toast.success(t("Password changed successfully!"));
      setFormValues({
        opassword: "",
        password: "",
        cpassword: "",
      });
    } catch (error) {
      if (error?.status === 422) {
        if (
          error?.data?.message ===
          "password_password_must_be_at_least_8_characters_long"
        ) {
          toast.error("Password must be at least 8 characters long.");
        } else if (error?.data?.message === "password_mismatch") {
          toast.error(t("Passwords do not match."));
        } else if (error?.data?.message === "old_password_not_valid") {
          toast.error(t("Old password not valid"));
        }
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  let tooltipInit = false;
  useEffect(() => {
    if (!tooltipInit) {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      [...tooltipTriggerList].forEach(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
      tooltipInit = true;
    }
  }, []);

  return (
    <div
      id="ChangePassword"
      className={`card cardSetting ${themeStatus?.[selectedTheme]}`}
    >
      <div className="card-header">
        <h4 className="card-title responsive-title">
          {t("Change Your Password")}
        </h4>
      </div>

      <div className="card-body">
        <div className="d-flex w-100 account-setting-responsiveness mt-3">
          <label
            className="form-label card-text"
            style={{ color: "var(--whiteToBlack)" }}
          >
            {t("Current Password")}
          </label>
          <div className="profile-visibility-select">
            <input
              type="text"
              className="form-control account-placeholder rounded-2 "
              placeholder={t("Enter current password")}
              name="opassword"
              value={formValues.opassword}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="d-flex w-100 account-setting-responsiveness mt-3">
          <label
            className="form-label card-text"
            style={{ color: "var(--whiteToBlack)" }}
          >
            {t("New Password")}
            <i
              className="bi-question-circle text-secondary ps-3"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={t("New Password")}
            />
          </label>
          <div className="profile-visibility-select">
            <input
              type="text"
              className="form-control account-placeholder rounded-2 "
              placeholder={t("Enter new password")}
              name="password"
              value={formValues.password}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="d-flex w-100 account-setting-responsiveness mt-3">
          <label
            className="form-label card-text"
            style={{ color: "var(--whiteToBlack)" }}
          >
            {t("Confirm New Password")}
            <i
              className="bi-question-circle text-secondary ps-3"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={t("Confirm New Password")}
            />
          </label>
          <div className="profile-visibility-select">
            <input
              type="text"
              className="form-control account-placeholder rounded-2 "
              placeholder={t("Confirm your new password")}
              name="cpassword"
              value={formValues.cpassword}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
      <div className="card-header p-0"></div>
      <div className="d-flex justify-content-end card-body pt-3">
        <button
          className="btn btn-primary edit-profile-btn p-0"
          onClick={handleSubmit}
          disabled={
            !formValues.opassword ||
            !formValues.password ||
            !formValues.cpassword
          }
        >
          {t("Save Changes")}
        </button>
      </div>
    </div>
  );
}

export default ChangePassword;
